export default __webpack_public_path__ + "locales/lv/DataReassignmentDialog.json?hash=8e94f2a42888ce7d3325d824a836f5f5";